import React, { useEffect, useRef } from "react";

export default function Table(props) {

    const tableRef = useRef(null);

    const {
        route = "",
        className = "",
        small = false,
        header = false,
        row_height = 30,
        row_key = "id",
        rowClass = () => { },
        onWheel = () => { },
        onRowClick = () => { },
        next = () => { },
        prev = () => { },
        width = 918,
        height = 273,
        offset = 380,
        data = [],
        current = {},
        columns = [],
        inline = false,
        display_only = false,
    } = props;


    const currentIndex = data.findIndex(item => item?.[row_key] === current?.[row_key]);

    let _class = className + " " + "ui-table-wrap";
    if (small) { _class += " small"; }
    if (header) { _class += " header"; }


    const getHeightStyle = () => {
    if (offset) {
        return {
            height: `calc(100vh - ${offset}px)`
        };
    }

    if (height === 'auto') {
        return {
            height: 'auto',
            minHeight: 0
        };
    }

    return {
        height: `${height}px`,
        minHeight: `${height}px`
    };
};

const getWidthStyle = () => {
    if (width === 'auto') {
        return "100%";
    }

    return `${width}px`;
};


    const getValueFromRowByKey = (_row, _key) => {

       
       
        const keys = _key.split('.');
        let value = _row;

        for (const key of keys) {
            if (value && key in value) {
                value = value[key];
            } else {
                return undefined; // Return undefined if the key path is invalid
            }
        }

        return value;
    };

    const renderRow = (_row, _col, _ind) => {

        let _row_class = rowClass(_row);
        let _stl = {
            width: (_col?.width) ? _col.width + "px" : "auto",
            textAlign: (_col?.align) ? _col.align : "right",
        }
        if (!_row) {
            return (<td style={_stl} key={_ind}>&nbsp;</td>)
        }

        let _v = getValueFromRowByKey(_row, _col?.key);

        if (typeof _col.render === 'function') {
            _v = _col.render(_row[_col?.key], _row);
        }
        return <td className={_row_class} key={_col.key}><div className="td" style={_stl}>{_v}</div></td>
    }

    const renderCol = (_col) => {
        let _stl = {
            width: (_col?.width) ? _col.width + "px" : "auto",
            textAlign: (_col?.align) ? _col.align : "right",
        }
        return (<th style={_stl} key={_col.key}>{_col.title}</th>)
    }

    useEffect(() => {
        if (tableRef.current) {
            const tableElement = tableRef.current;
            const rowTop = currentIndex * row_height;
            const rowBottom = rowTop + row_height;
            const visibleTop = tableElement.scrollTop;
            const visibleBottom = visibleTop + tableElement.clientHeight - 29;
            if (rowTop < visibleTop) {
                // Scroll the table to make the row fully visible at the top
                tableElement.scrollTop = rowTop;
            } else if (rowBottom > visibleBottom) {
                // Scroll the table to make the row fully visible at the bottom
                tableElement.scrollTop = rowBottom - tableElement.clientHeight + 24;
            }
        }
    }, [currentIndex]);

    const onKeyDown = (e) => {

        const visibleTop = tableRef.current.scrollTop;
        const visibleBottom = visibleTop + tableRef.current.clientHeight - 29;
        const rows = Math.floor(Math.abs(visibleTop - visibleBottom) / row_height);
        switch (e.key) {
            case 'ArrowDown':
                next();
                break;
            case 'ArrowUp':
                prev();
                break;
            case 'PageDown':
                next(rows);
                break;
            case 'PageUp':
                prev(rows);
                break;
            default:
                break;
        }
    }

    const getAdjustedColumns = () => {
        const totalFixedWidth = columns.reduce((sum, col) => sum + (col.width || 0), 0);
        const growable = columns.filter(col => col.grow);
        const shrinkable = columns.filter(col => col.shrink);

        const delta = width - totalFixedWidth;

        // Case: Not enough total width – grow columns
        if (delta > 0 && growable.length) {
            const extraPerGrow = delta / growable.length;
            return columns.map(col => ({
                ...col,
                width: col.width + (col.grow ? extraPerGrow : 0),
            }));
        }

        // Case: Too much total width – shrink columns
        if (delta < 0 && shrinkable.length) {
            const overPerShrink = Math.abs(delta) / shrinkable.length;
            return columns.map(col => ({
                ...col,
                width: Math.max(0, col.width - (col.shrink ? overPerShrink : 0)),
            }));
        }

        // No adjustment needed
        return columns;
    };

    return (
        <div style={{ "width": getWidthStyle(), "height": getHeightStyle(), "minHeight": height + "px" }} className={_class} >
            {(header && <div className={"ui-table-header"}>{header}</div>)}
            <div ref={tableRef} className={(inline) ? "ui-table-container inline" : "ui-table-container"} style={getHeightStyle()}>
                <table onKeyDown={(e) => onKeyDown(e)} onWheel={(e) => onWheel(e)} style={{width : getWidthStyle()}} tabIndex="0" className={(inline) ? 'ui-table inline' : "ui-table"}>
                    <thead>
                        <tr>

                            {columns.map(col => {
                                return renderCol(col);
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, ind) => {
                            let row = (ind >= 0 && ind < data.length) ? data[ind] : null;
                            return (
                                <tr onClick={(e) => onRowClick(item, e, ind)} className={(currentIndex === ind && !display_only) ? "ui-row-selected" : "ui-row"} key={item[row_key]} >
                                    {columns.map(col => {
                                        return renderRow(row, col, ind);
                                    })}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>

    )
}